import {FmlxToast} from 'fmlx-common-ui';
import {uniqueId} from 'lodash';

import {Toast} from '../../constants/actionType';

const initialState = {
  id: uniqueId(),
  show: false,
  variant: FmlxToast.Variant.INFO,
  title: '',
  content: '',
  timeout: null,
  placement: FmlxToast.Placement.TOP_CENTER,
};

export default function toastState(state = initialState, action = {}) {
  switch (action.type) {
    case Toast.SHOW:
      return {
        ...state,
        id: action.id,
        show: action.show,
        variant: action.variant,
        title: action.title,
        content: action.content,
        timeout: action.timeout,
        placement: action.placement,
      };
    case Toast.HIDE:
      return initialState;
    default:
      return state;
  }
}
